import React from 'react'
import _ from 'lodash'

import ReportTable from '../report_table'
import MemberTableOrg from './report_member_table'
import * as Helper from '../../../../helpers/helper'
import { localeNumberFormatter, truncateEnd } from '../helpers'

// port of cowebapp analytics/components/team/report_org_table.js
const ReportTableOrg = (props) => {

  const expandRowComp = (row) => {
    return (<MemberTableOrg
      memberData={row.stats}
      breakdown={props.userReportData.breakdown}
      id={row.user_id}
    />
    )
  }

  const expandRow = {
    className: 'expanding-row',
    parentClassName: 'parent-expand-row',
    renderer: row => expandRowComp(row)
  }

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const emailFormatter = (cell, row) => {
    return (
      <div
        className="d-flex org-email-column"
        title={row.email}
      >
        <div className='word-break-all'>
          {truncateEnd(Helper.capitalizeFirstLetter(_.isEmpty(row.name) ? '-' : row.name), 18)}
          <small>
            <div className="d-flex">
              <span className='word-break-all'>
                {truncateEnd(row.email, 24)}
              </span>
            </div>
          </small>
        </div>
      </div>
    )
  }

  const getTableData = () => {
    let tableData = []
    props.tableData.forEach((data) => {
      let total = 0
      let ev_billable = 0
      let ef_billable = 0
      let prospect_billable = 0
      let js_widget_billable = 0
      let data_pulse_billable = 0

      data.stats.forEach((stat) => {
        ev_billable = ev_billable + stat.ev_billable
        ef_billable = ef_billable + stat.ef_billable
        prospect_billable = prospect_billable + stat.prospect_billable
        js_widget_billable = js_widget_billable + stat.js_widget_billable
        data_pulse_billable = data_pulse_billable + stat.data_pulse_billable
        total = total + stat.total
      })

      tableData.push({
        email: data.email,
        stats: data.stats,
        user_id: data.user_id,
        name: data.name,
        total: total,
        ev_billable: ev_billable,
        ef_billable: ef_billable,
        prospect_billable: prospect_billable,
        js_widget_billable: js_widget_billable,
        data_pulse_billable: data_pulse_billable
      })

    })
    return tableData
  }

  const data = getTableData()

  const rowClasses = 'custom-row-class'

  const colWidth = { width: '14%' }
  const formatNumber = localeNumberFormatter('-')

  const columns = [
    {
      dataField: 'email',
      text: 'Member',
      formatter: emailFormatter,
      headerStyle: { width: '16%' },
      style: { width: '16%' },
      sort: true
    },
    {
      dataField: 'total',
      text: 'Total Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Total'
    },
    {
      dataField: 'ev_billable',
      text: 'Email Verifier',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Verifier'
    },
    {
      dataField: 'ef_billable',
      text: 'Email Finder',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Finder'
    },
    {
      dataField: 'prospect_billable',
      text: 'Prospect',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'js_widget_billable',
      text: 'Form Guard',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'data_pulse_billable',
      text: 'Data Pulse',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true
    }
  ]

  const defaultSorted = [{
    dataField: 'total',
    order: 'desc'
  }]

  return (
    <div className="report-table">
      <ReportTable
        wrapperClasses="table-report-org table-responsive"
        expandRow={expandRow}
        noDataIndication={noDataIndication}
        keyField="user_id"
        data={data}
        columns={columns}
        rowClasses={rowClasses}
        defaultSorted={defaultSorted}
      />
    </div>
  )
}

export default ReportTableOrg
